export const GET_PIP_EPOS_OBJECTIVES_LIST_PENDING = 'GET_PIP_EPOS_OBJECTIVES_LIST_PENDING';
export const GET_PIP_EPOS_OBJECTIVES_LIST_FULFILLED = 'GET_PIP_EPOS_OBJECTIVES_LIST_FULFILLED';
export const GET_PIP_EPOS_OBJECTIVES_LIST_REJECTED = 'GET_PIP_EPOS_OBJECTIVES_LIST_REJECTED';

const initialState = {
  pipEposObjectives: [],
  fetching: false,
  fetched: false,
  errors: {}
};

export default function pipEposObjectivesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PIP_EPOS_OBJECTIVES_LIST_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_PIP_EPOS_OBJECTIVES_LIST_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        pipEposObjectives: action.payload.data
      };
    }
    case GET_PIP_EPOS_OBJECTIVES_LIST_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
